export default __webpack_public_path__ + "assets/ed33f6d7d289fe41899b558b07414de6.png";